<app-lms-modal-frame [title]="'Compliance Notification'" [pageHeadWidth]="900">
  <div modal-body>
    <h5>Client is PIP/PEP and an email will be sent to Compliance. <br />Please complete this form.</h5>
    <div class="container-fluid">
      <div class="row center-screen">
        <form *ngIf="agentComplianceNotificationForm" [formGroup]="agentComplianceNotificationForm">
          <div class="card-body p-1">
            <ng-container class="row center-screen align-items-center">

              <table w900 class="table table-striped table-auto table-sm "
                style="text-align: start; vertical-align: bottom;">
                <caption>Client Detials: {{clientSearch.clientResult.quoteId}}</caption>
                <tbody>
                  <tr>
                    <td style="width: 25%;">Full names</td>
                    <td>
                      {{clientSearch.clientResult.fullNames || clientSearch.clientResult.firstName || 'err'}}
                    </td>

                    <td>Surname</td>
                    <td>
                      {{clientSearch.clientResult.lastName || 'err'}}
                    </td>
                  </tr>

                  <tr>
                    <td>ID Number</td>
                    <td>
                      {{clientSearch.clientResult.idNumber || 'err'}}
                    </td>

                    <td>Risk Score</td>
                    <td>
                      {{clientSearch.clientResult.riskScore || 0}}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table w900 class="table table-striped table-auto table-sm"
                style="text-align: start; vertical-align: bottom;">
                <tbody>
                  <tr>
                    <td>Occupation</td>
                    <td>
                      <input class="form-control ms-0" placeholder="Occupation" formControlName="occupation"
                        autofocus required lmsNoSpecial>
                      <div
                        *ngIf="occupation?.errors && (occupation?.dirty || occupation?.touched)">
                        <label mdbLabel class="error-label"> Occupation is required.</label>
                      </div>
                    </td>

                    <td>Gender</td>
                    <td>
                      <mdb-select class="form-control ms-0 select table-control " formControlName="gender"
                      [autoSelect]="false" required autofocus>
                        <mdb-option *ngFor="let genders of lstGenders" [value]="genders.value">
                      {{genders.description}}</mdb-option>
                      </mdb-select>
                      <div
                        *ngIf="gender?.errors && (gender?.dirty || gender?.touched)">
                        <label mdbLabel class="error-label"> Gender is required.</label>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>Marital Status</td>
                    <td>
                      <mdb-select class="form-control ms-0 select table-control " formControlName="maritalStatus"
                      [autoSelect]="false" required autofocus>
                        <mdb-option *ngFor="let mstatus of lstCompMAritalStatus" [value]="mstatus.value">
                      {{mstatus.description}}</mdb-option>
                      </mdb-select>
                      <div
                        *ngIf="maritalStatus?.errors && (maritalStatus?.dirty || maritalStatus?.touched)">
                        <label mdbLabel class="error-label"> Maritial Status is required.</label>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>Address line 1</td>
                    <td>
                      <input class="form-control ms-0" placeholder="Address line 1" formControlName="homeLine1"
                        autofocus required lmsNoSpecials>
                      <div
                        *ngIf="homeLine1?.errors && (homeLine1?.dirty || homeLine1?.touched)">
                        <label mdbLabel class="error-label"> Address is required.</label>
                      </div>
                    </td>

                    <td>Address line 2</td>
                    <td>
                      <input class="form-control ms-0" placeholder="Address line 2" formControlName="homeLine2"
                        autofocus lmsNoSpecials>
                    </td>
                  </tr>

                  <tr>
                    <td>Suburb</td>
                    <td>
                      <input class="form-control ms-0" formControlName="homeSuburb" placeholder="Suburb" autofocus
                        required lmsNoSpecials>
                      <div
                        *ngIf="homeSuburb?.errors && (homeSuburb?.dirty || homeSuburb?.touched)">
                        <label mdbLabel class="error-label"> Suburb is required.</label>
                      </div>
                    </td>

                    <td>Town / City</td>
                    <td>
                      <input class="form-control ms-0" placeholder="Town" formControlName="homeTown" autofocus required>
                      <div
                        *ngIf="homeTown?.errors && (homeTown?.dirty || homeTown?.touched)">
                        <label mdbLabel class="error-label"> Town is required.</label>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>Area code</td>
                    <td>
                      <input class="form-control ms-0" maxlength="4" placeholder="Area code"
                        formControlName="homeAreaCode" autofocus required
                        (keypress)="($event.charCode >= 48 && $event.charCode < 58)">
                      <div
                        *ngIf="homeAreaCode?.errors && (homeAreaCode?.dirty || homeAreaCode?.touched)">
                        <label mdbLabel class="error-label"> Area Code is required.</label>
                      </div>
                    </td>

                    <td>Province</td>
                    <td>
                      <mdb-select class="form-control ms-0 select table-control" formControlName="homeProvince"
                       [autoSelect]="false"
                        autofocus required>
                         <mdb-option *ngFor="let province of lstProvinces" [value]="province.value">{{province.description}}</mdb-option>
                      </mdb-select>
                      <div
                        *ngIf="homeProvince?.errors && (homeProvince?.dirty || homeProvince?.touched)">
                        <label mdbLabel class="error-label"> Province is required.</label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div modal-actions>
    <button class="btn btn-primary rounded-1" mdbRipple type="button" [textContent]="'Submit'" (click)="submit()"></button>
  </div>
</app-lms-modal-frame>
